// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".student-dashboard-related-courses--layout {\n  display: flex;\n  flex-direction: column;\n  gap: 12px; }\n  .student-dashboard-related-courses--layout .student-dashboard-related-courses--list {\n    display: grid;\n    grid-template-columns: repeat(2, 50%);\n    gap: 10px; }\n  @media screen and (max-width: 800px) {\n    .student-dashboard-related-courses--layout .student-dashboard-related-courses--list {\n      grid-template-columns: 1fr; } }\n", ""]);
// Exports
module.exports = exports;
